/**
 * Styles aligned with Figma Add Widget picker (CC-15280).
 */
const addWidgetModalStyles = () => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    maxHeight: '60vh',
    overflowY: 'auto',
  },
  category: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
  },
  categoryHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    width: '100%',
  },
  categoryTitle: {
    color: 'var(--grey-90, #707070)',
    margin: 0,
    textTransform: 'uppercase',
  },
  categoryAttributionRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    width: '100%',
  },
  categoryMark: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    borderRadius: 10,
    backgroundColor: '#000066',
    flexShrink: 0,
    color: '#ffffff',
    '& .MuiSvgIcon-root': {
      fontSize: 20,
    },
  },
  categoryMarkImage: {
    width: 24,
    height: 24,
    objectFit: 'contain',
    display: 'block',
  },
  categoryAttribution: {
    color: '#000066',
    letterSpacing: '0.24px',
    margin: 0,
  },
  typeList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%',
  },
});

export default addWidgetModalStyles;

export const AddWidgetModalStyles = () => ({
  '& .modal-footer': {
    display: 'none',
  },
});
